import { Container, SectionFull, Link, ServiceTile } from "components"
import React from "react"
import styled from "styled-components"
import tw from "twin.macro"
import useTilesStagger, {
  TilesStaggerVars,
} from "logic/hooks/use-tiles-stagger"
import { Portfolios } from "model/content"

import { AnchorToGoTo } from "components/AnchorToGoTo"
import { LastWordColoured } from "components/LastWordColoured"
import {
  TitleProps,
  Title,
  Container as DescribedHContainer,
  Description,
} from "./DescribedHeading"

const Section = styled(SectionFull)`
  ${tw``}
`

export const Content = styled.div`
  ${tw`relative py-16 z-20`}
`

const TileList = styled.ul`
  ${tw`grid md:grid-cols-2 xl:grid-cols-4 p-px pb-0`};
`

const TileContainer = styled.li`
  ${tw`relative -mr-px z-10`};
`

const staggerOptions: TilesStaggerVars = {
  stagger: { from: "random" },
  slideInOnMobile: true,
}

interface PortfolioSectionProps {
  portfolios: Portfolios
  title: string
  description: string
}

export const DescribedHeadingFirstWordWhite: React.FC<TitleProps> = ({
  title,
  description,
}) => {
  if (!title) {
    return null
  }
  // eslint-disable-next-line consistent-return
  return (
    <DescribedHContainer>
      <Title>
        <LastWordColoured text={title} />
      </Title>
      <Description>{description}</Description>
    </DescribedHContainer>
  )
}

const PortfolioSection: React.FC<PortfolioSectionProps> = ({
  title,
  description,
  portfolios,
}) => {
  const { sectionRef, tilesRefs } = useTilesStagger(false, staggerOptions)

  return !portfolios || portfolios.length === 0 ? null : (
    <Section>
      <AnchorToGoTo id="portfolio" />
      <Container>
        <Content>
          <DescribedHeadingFirstWordWhite
            title={title}
            description={description}
          />
        </Content>
      </Container>
      <TileList ref={sectionRef}>
        {portfolios.map((portfolioItem, i) => (
          <TileContainer key={portfolioItem.heading}>
            <Link to={`/portfolio/${portfolioItem.slug}`}>
              <ServiceTile
                title={portfolioItem.heading}
                hover
                location={portfolioItem.location}
                image={{ fluid: portfolioItem.image?.fluid }}
                ref={e => (tilesRefs.current[i] = e)}
              >
                {portfolioItem.homepageDescription}
              </ServiceTile>
            </Link>
          </TileContainer>
        ))}
      </TileList>
    </Section>
  )
}

export default PortfolioSection
